import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule NavigationFuncMenuSvgModule
 */
@Component({
  selector: 'svg[ivyMaiaNavigationFuncMenu]',
  template: '<svg:g class="nc-icon-wrapper" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><svg:path data-color="color-2" fill="none" stroke-miterlimit="10" d="M3.2 12h17.6" stroke-width="1.04"></svg:path><svg:path fill="none" stroke-miterlimit="10" d="M3.2 6.4h17.6" stroke-width="1.04"></svg:path><svg:path fill="none" stroke-miterlimit="10" d="M3.2 17.6h17.6" stroke-width="1.04"></svg:path></svg:g>',

  styles: [
    ':host { fill: currentColor; stroke: currentColor; }',
      ],

  host: {
    'viewBox': '0 0 24 24',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationFuncMenuSvgComponent {
}

@NgModule({
  declarations: [
    NavigationFuncMenuSvgComponent,
  ],
  exports: [
    NavigationFuncMenuSvgComponent,
  ],
})
export class NavigationFuncMenuSvgModule {}
